import styles from "./Styles/typography.module.scss";

export const enum Typography
{
    H1,
    H2,
    H3,
    H4,
    H4_5,
    H5,
    H6,
    H7,
    H8,
    P1,
    P2,
    P3,
    P4,
    P5Caption,
    T1,
    T2,
    Button,
    PLarge,
    PLargeBold,
    Quote,
    MH4,
    MNavItem,
    MH1DH2,
    MH2DH3,
    MH2DH5,
    MH7DH8,
    MP2DH6,
    MP3DH5,
}

const typographyClassMap: Record<Typography, string> = {
    [Typography.H1]: "h1",
    [Typography.H2]: "h2",
    [Typography.H3]: "h3",
    [Typography.H4]: "h4",
    [Typography.H4_5]: "h4_5",
    [Typography.H5]: "h5",
    [Typography.H6]: "h6",
    [Typography.H7]: "h7",
    [Typography.H8]: "h8",
    [Typography.P1]: "p1",
    [Typography.P2]: "p2",
    [Typography.P3]: "p3",
    [Typography.P4]: "p4",
    [Typography.P5Caption]: "p5-caption",
    [Typography.T1]: "t1",
    [Typography.T2]: "t2",
    [Typography.Button]: "button",
    [Typography.PLarge]: "p-large",
    [Typography.PLargeBold]: "p-large-bold",
    [Typography.Quote]: "quote",
    [Typography.MH4]: "m-h4",
    [Typography.MNavItem]: "m-nav-item",
    [Typography.MH1DH2]: "m-h1-d-h2",
    [Typography.MH2DH3]: "m-h2-d-h3",
    [Typography.MH2DH5]: "m-h2-d-h5",
    [Typography.MH7DH8]: "m-h7-d-h8",
    [Typography.MP2DH6]: "m-p2-d-h6",
    [Typography.MP3DH5]: "m-p3-d-h5",
};

export const typographyClass = (typography?: Typography): string | undefined => typography !== undefined ? styles[typographyClassMap[typography]] : undefined;
